module.exports = __webpack_public_path__ + "static/media/dz.f11b11f6.svg";